<template>
  <v-simple-table dense>
    <template v-slot:default>
      <tbody>
        <tr v-for="customer in customers" :key="customer.uuid" >
          <td class="text-start">
            {{ customer.name }}
          </td>
          <td class="text-center">
            <v-icon dense small color="green" v-if="customer.nileUgApplication">mdi-check</v-icon>
          </td>
          <td class="text-right">
            <v-btn small color="primary" :to="{name: targetRoute, query: { uuid: customer.uuid } }" class="mr-2" >
              <Currency :value="balances.sbg_credit[customer.uuid] || 0" v-if="(balances.sbg_credit[customer.uuid] || 0)>0" />
              <v-icon dense small v-else>mdi-text-account</v-icon>
            </v-btn>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>




<script>
  import Currency from '@/components/Currency';


  export default {

    components: { Currency },

    props: ['customers', 'balances', 'drafts'],

    data: () => ({
    }),

    computed: {
      search() { return this.$store.getters.search; },
      targetRoute() { return (this.drafts ? 'NileRegisterContact' : 'ShowCustomer') },
      // list() {
      //   const regex = new RegExp(this.search, "i");
      //   return this.customers.filter( e => regex.test(e.name) ).sort( (a,b) => { return (a.name < b.name ? -1 : 1); } );
      // },
    },

  }
</script>


<i18n>
{
  "en": {
  },
  "es": {
  },
  "sw": {
  }
}
</i18n>
